<template>
  <div v-loading="isLoading">
    <el-row class="mb-2">
      <el-col>
        <el-card>
          <el-row>
            <el-col :span="8">
              <span class="text-center">
                <strong>Árvore -  {{ arvore.nome}}</strong>
              </span>
            </el-col>
            <el-col :span="16" align="right">
              <el-tooltip content="Excluir Árvore">
                <el-button icon="icon-trash" type="danger" size="mini" @click="excluir"></el-button>
              </el-tooltip>
            </el-col>
          </el-row>

        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <el-card class="mr-2">
          <div slot="header" class="clearfix">
            <strong>Grupos</strong>
          </div>
          <ul class="list-group">
            <li v-bind:class="{ 'indicador-active': indicador.id === indicadorSelected.id }"
                class="list-group-item clickable" v-for="indicador in parents" @click="onChangeGrupo(indicador)">
              <span style="font-size: .8em ; font-weight: bold"> {{indicador.indicador_nome}}</span>
            </li>
          </ul>
        </el-card>
      </el-col>
      <transition name="fade" mode="out-in">
        <el-col :span="20" v-if="indicadorSelected">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <strong> {{indicadorSelected.indicador_nome}} Indicadores</strong>
              <el-button-group class="pull-right">
                <el-button size="mini" type="success" @click="salvar" icon="fa fa-floppy-o"></el-button>
              </el-button-group>
            </div>
            <table class="table table-striped table-bordered" v-if="listIndicadores.length">
              <thead class="thead-dark">
              <tr>
                <th class="text-center">ID</th>
                <th class="text-center">Peso</th>
                <th class="text-center" v-show="isGrupoRaiz">Partida</th>
                <th class="text-center">Meta</th>
                <th class="text-center" v-show="isGrupoRaiz">Desafio</th>
                <th class="text-center">#</th>
              </tr>
              </thead>
              <draggable v-model="listChildrens" :element="'tbody'">
                <tr v-for="item in listChildrens" key="item.indicador_id">
                  <td style="font-size: .8em ; font-weight: bold">{{item.indicador_nome}}</td>
                  <td class="text-right">
                    <el-input-number v-model="item.peso" controls-position="right" size="small"></el-input-number>
                  </td>
                  <td class="text-right" v-show="isGrupoRaiz">
                    <el-input-number v-model="item.partida" controls-position="right" size="small"></el-input-number>
                  </td>
                  <td class="text-right">
                    <el-input-number v-model="item.valor" controls-position="right" size="small"></el-input-number>
                  </td>
                  <td class="text-right" v-show="isGrupoRaiz">
                    <el-input-number v-model="item.desafio" controls-position="right" size="small"></el-input-number>
                  </td>
                  <td class="text-right">
                    <el-switch v-model="item.ativo"></el-switch>
                  </td>
                </tr>
              </draggable>
              <tbody>
              <tr>
                <td></td>
                <td class="text-right">
                  <strong>{{somaDoPesos}}</strong>
                </td>
                <td colspan="4"></td>
              </tr>
              </tbody>
            </table>
          </el-card>
        </el-col>
      </transition>
    </el-row>
  </div>

</template>

<script>
  import {mapActions} from 'vuex'
  import {MessageBox, Notification} from 'element-ui'
  import draggable from 'vuedraggable'

  export default {
    name: "Show",
    components: {
      draggable
    },
    data() {
      return {
        listChildrens: [],
        isLoading: false,
        indicadorSelected: {},
        indicadorRaiz: {indicador_id: null, indicador_nome: 'Raiz'},
        arvore: {}
      }
    },
    computed: {
      id() {
        return this.$route.params.id
      },
      parents() {
        const parentsIds = collect(this.arvore.folhas).where('ativo', true).pluck('parent_id').all()
        const raiz = {indicador_id: null, indicador_nome: 'Raiz'}
        return collect(this.arvore.folhas).whereIn('indicador_id', parentsIds).prepend(raiz).all();
      },
      childrens() {
        return collect(this.arvore.folhas).filter(function (value, key) {
          return value.parent_id != null;
        }).all();
      },
      isGrupoRaiz() {
        return this.indicadorRaiz.id === this.indicadorSelected.id
      },
      listIndicadores() {
        return collect(this.arvore.folhas).where('parent_id', this.indicadorSelected.indicador_id).all()
      },
      somaDoPesos() {
        const total = collect(this.listChildrens)
          .where('ativo', true)
          .sum('peso')
        return _.isNumber(total) ? total.toFixed(2) : 0
      }
    },
    methods: {
      ...mapActions('Arvore', ['atualizaFolhas']),
      async excluir() {

        try {
          await  MessageBox.confirm("Deseja excluir o registro?", "ATENÇÃO", {type: 'warning'})
          this.isLoading = true
          const {data} = await axios.delete(`${process.env.API_PATH}/arvore/${this.id}`)
          this.$router.push('/arvore')
          Notification.success("Árvore Excluída com sucesso.")
        } catch (error) {
          console.log(error)
          Notification.info("Atualização Cancelada.")
        } finally {
          this.isLoading = false
        }

      },
      onChangeGrupo(indicador) {
        this.indicadorSelected = {...indicador}
        let {indicador_id} = this.indicadorSelected
        indicador_id = !indicador_id ? '' : indicador_id
        let ordemParent = collect(this.arvore.indicadores_ordem).get(indicador_id)
        this.listChildrens = collect(this.arvore.folhas)
          .where('parent_id', this.indicadorSelected.indicador_id)
          .sortBy(function (folha, key) {
            return collect(ordemParent).search(folha.indicador_id)
          }).all()
      },
      async salvar() {
        try {
          await  MessageBox.confirm("Deseja atualizar os dados?", "ATENÇÃO", {type: 'warning'})
          const keysValid = ['ativo', 'indicador_id', 'peso', 'valor', 'desafio', 'partida', 'centro_custo_id', 'id']
          let {indicador_id} = this.indicadorSelected
          indicador_id = indicador_id == null ? 0 : indicador_id
          const folhas = {... this.listChildrens.map(item => _.pick(item, keysValid))}
          this.isLoading = true
          await this.atualizaFolhas({folhas, parentId: indicador_id, arvoreid: this.arvore.id})
          this.isLoading = false
          Notification.success("Metas atualizadas com sucesso.")
          await this.load()
        } catch (error) {
          this.isLoading = false
          console.log(error)
          Notification.info("Atualização Cancelada.")
        }
      },
      async load() {
        this.isLoading = true
        try {
          const {data} = await axios.get(`${process.env.API_PATH}/arvore/${this.id}`)
          this.arvore = {...data}
        } catch (e) {

        } finally {
          this.isLoading = false
        }
      }
    },
    async mounted() {
      await this.load()
      this.onChangeGrupo({...this.indicadorRaiz})
    }
  }
</script>

<style scoped>
  .indicador-active {
    background-color: #9933CC;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/features/Arvore/Show.vue